var SIZING_STYLE = [
    "letter-spacing",
    "line-height",
    "padding-top",
    "padding-bottom",
    "font-family",
    "font-weight",
    "font-size",
    "font-variant",
    "text-rendering",
    "text-transform",
    "width",
    "text-indent",
    "padding-left",
    "padding-right",
    "border-width",
    "box-sizing",
    "word-break",
    "white-space",
];
var TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n";
var hiddenTextarea;
export function calculateNodeStyling(node) {
    var style = window.getComputedStyle(node);
    var boxSizing = style.getPropertyValue("box-sizing") ||
        style.getPropertyValue("-moz-box-sizing") ||
        style.getPropertyValue("-webkit-box-sizing");
    var paddingSize = parseFloat(style.getPropertyValue("padding-bottom")) +
        parseFloat(style.getPropertyValue("padding-top"));
    var borderSize = parseFloat(style.getPropertyValue("border-bottom-width")) +
        parseFloat(style.getPropertyValue("border-top-width"));
    var sizingStyle = SIZING_STYLE.map(function (name) { return name + ":" + style.getPropertyValue(name); }).join(";");
    var nodeInfo = {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize,
        boxSizing: boxSizing,
    };
    return nodeInfo;
}
export default function calcTextareaHeight(textareaNode, minRows, maxRows) {
    if (!hiddenTextarea) {
        hiddenTextarea = document.createElement("textarea");
        document.body.appendChild(hiddenTextarea);
    }
    var _a = calculateNodeStyling(textareaNode), sizingStyle = _a.sizingStyle, paddingSize = _a.paddingSize, borderSize = _a.borderSize, boxSizing = _a.boxSizing;
    hiddenTextarea.setAttribute("style", sizingStyle + ";" + TEXTAREA_STYLE);
    hiddenTextarea.value = textareaNode.value || textareaNode.placeholder || "";
    var height = hiddenTextarea.scrollHeight;
    var isBorderbox = boxSizing === "border-box";
    var isContentbox = boxSizing === "content-box";
    if (isBorderbox) {
        height += borderSize;
    }
    else if (isContentbox) {
        height -= paddingSize;
    }
    hiddenTextarea.value = "";
    var result = { overflowY: "hidden" };
    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
    // hiddenTextarea?.parentNode?.removeChild(hiddenTextarea);
    // // @ts-ignore
    // hiddenTextarea = null;
    var calcHeight = function (rows) {
        var rowsHeight = singleRowHeight * rows;
        if (isBorderbox) {
            rowsHeight = rowsHeight + paddingSize + borderSize;
        }
        return rowsHeight;
    };
    if (minRows) {
        var minHeight = calcHeight(minRows);
        height = Math.max(minHeight, height);
        result.minHeight = minHeight + "px";
    }
    if (maxRows) {
        height = Math.min(calcHeight(maxRows), height);
        if (calcHeight(maxRows) <= height) {
            result.overflowY = "auto";
        }
    }
    result.height = height + "px";
    return result;
}
//# sourceMappingURL=calcTextAreaHeight.js.map